import { useState } from 'react';
import { Button, Card, Col, Row, Tag, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import SupportedMedia from './SupportedMedia';

const ListItem = (props) => {

  const { item } = props;
  const { isNew, description, title, icons } = item;

  const [ isLocationOpen, setLocationOpen ] = useState(false);

  const renderLocations = () => {
    return (
      <ul className="list-content"> 
        { item.locations.map(location => (<li>{location.join(" > ")}</li>))}
      </ul>
     )
  }

  return (
    <Col key={item.id} xs={24}>
      <Card className="list-item shadow" bordered={false} description={item.description}>
        <Row gutter={12} justify="center" align="center">
          
          <Col className="card-header" xs={{order:2, span: 24}} sm={{order:1, span: 9}}>
            <div className="card-image-container">
              { isNew === true && <Tag color="#f50" style={{position: 'absolute', top: "-8px", right: "52%"}}><strong>New</strong></Tag> }
              { 
                icons.map((icon,i) => (
                  <Tooltip key={`${item.id}-${i}`} title={`${icon.type}: ${icon.title} \r\n Definition: ${icon.definition}`}>
                    <img className="card-image" src={icon.src} alt={icon.title} width={64} />
                  </Tooltip>
                )) 
              }
            </div>
            <div className="card-type-container">
              <h4 className="card-subheading">Framework {" "}
              <Tooltip title={<>There are three lenses, or rather &quot;presences,&quot; that we can view our digital learning design through: teaching presence, social presence, and cognitive presence. <Button size="small" block type="link" href="https://lf.westernsydney.edu.au/engage/technology/digital-learning-thresholds" title="Find out more on The Hub" target="_blank" rel="noreferrer" className="btn-on-dark">More info</Button></>}>
                <QuestionCircleOutlined className="icon-smaller" />
              </Tooltip>
              </h4>
              {(item.framework != null) ? item.framework.join(", ") : "N/A"}
            
              <h4 className="card-subheading">Category {" "}
              <Tooltip title={<>To further promote a greater breadth of thinking around the Digital Learning Thresholds, we have categorised them into four broad categories. <Button size="small" block type="link" href="https://lf.westernsydney.edu.au/engage/technology/digital-learning-thresholds" title="Find out more on The Hub" target="_blank" rel="noreferrer" className="btn-on-dark">More info</Button></>}>
                <QuestionCircleOutlined className="icon-smaller" />
              </Tooltip>
              </h4>
              {(item.categories != null) ? item.categories.join(", ") : "N/A"}
            </div>
          </Col>
            
          <Col xs={{order:1, span: 24}} sm={{order:2, span: 15}}>  
            <div>   
              <a href={item.link} rel="noreferrer" target="_blank" title="Find out more"><h2 className="card-title">{title}</h2></a>
              <p className="card-description">{description}</p>
            </div>
            <div>
              <Tooltip title="Implementing this threshold may include editing media such as audio, images, interactives, Learn2Learn, text, or video.">
                <h3 style={{display: 'inline-block'}} className="card-subheading">Related Media <QuestionCircleOutlined className="icon-smaller" /></h3>
              </Tooltip>
              <div className="icon-container">
                <SupportedMedia media={item.supportedMedia} />
              </div>
            </div>
            {item.locations.length > 0 && (<div>
              <Tooltip title="Items within Cortex applicable to this threshold.">
                <h3 style={{display: 'inline-block'}} className=""><a href="#1" onClick={e => setLocationOpen(!isLocationOpen)}>Cortex Locations <QuestionCircleOutlined className="icon-smaller" /></a></h3>
              </Tooltip>
              { isLocationOpen && <div className="">
                {renderLocations()}
              </div> }
            </div>)}
          </Col>
        </Row>
        
      </Card>
    </Col>
  );
}

export default ListItem;